import { Button, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { ModalWarningIcon } from 'src/assets/icons'

import './index.scss'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

function HasExceptionsToResolveModal(props: Props) {
  const { isOpen, onClose, onConfirm } = props
  const { t } = useTranslation()

  return (
    <ActionConfirmationModal
      icon={<ModalWarningIcon />}
      title={<Typography className='modal-title'>{t('ClientSetup:addNewClient.modal.hasExceptionsToResolve.title')}</Typography>}
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        <Typography className='modal-description'>
          {t('ClientSetup:addNewClient.modal.hasExceptionsToResolve.description')}
        </Typography>
      }
      footer={[
        <Button
          size='middle'
          onClick={() => {
            onClose()
          }}
        >
          {t('common:no')}
        </Button>,
        <Button size='middle' type='primary' onClick={onConfirm}>
          {t('common:yes')}
        </Button>,
      ]}
    />
  )
}

export default HasExceptionsToResolveModal
